// extracted by mini-css-extract-plugin
export default {"returnButtonWrap":"styles_returnButtonWrap__mDupX","returnButtonIcon":"styles_returnButtonIcon__6TDgR"};